 import { buildParamString, IAPIResponse } from "@mindmemobile/mm-shared-global";
import { Observable } from "rxjs";
import { HttpService, url } from "../../shared/services";
import { IAPIOrdersGridModel } from "../../shared/interfaces";

class OrderService {
  private httpService: HttpService;

  constructor() {
      this.httpService = new HttpService(
          undefined,
          `${process.env.REACT_APP_API_KEY}`,
          process.env.REACT_APP_API_BASE_URL,
      );
  }

  getOrders(
      accountId: string,
      pageNumber: number,
      pageSize: number,
      sortColumn: string,
      searchValue = '',
  ): Observable<IAPIResponse<IAPIOrdersGridModel[]>> {
      const params: string = buildParamString({
          accountId: accountId,
          pageNumber: pageNumber,
          pageSize: pageSize,
          sortColumn: sortColumn,
          searchValue: searchValue,
      });
      return this.httpService.get<IAPIResponse<IAPIOrdersGridModel[]>>(url.getOrdersGridData, params);
  }
}
export default new OrderService();
